export default __webpack_public_path__ + "static/media/gudjard.272c8922.svg";